import React from 'react';
import { useSelector } from 'react-redux';

import { trackSelectPromotion } from '@browsing/tracking';
import { getCategoryTabId } from '@client/redux/modules/mylounge';

import { CampaignCardCompact } from '../../campaigns/components/campaignCardCompact';
import { TrackingParams } from '../../hooks';

type CampaignCardBaseProps = Omit<Parameters<typeof CampaignCardCompact>[0], 'onClick'>;

interface CampaignsCarouselCardProps extends CampaignCardBaseProps {
    onClick?: () => void;
    trackingParams: TrackingParams;
}

const CampaignsCarouselCard = ({
    campaign,
    index,
    onClick,
    trackingParams,
    ...props
}: CampaignsCarouselCardProps) => {
    const categoryTabId = useSelector(getCategoryTabId);

    const handleClick = () => {
        trackSelectPromotion({
            element: trackingParams.element,
            creativeName: trackingParams.creativeName,
            itemListName: trackingParams.itemListName,
            item: {
                campaignIdentifier: campaign.campaignId,
                categoryId: categoryTabId,
                index,
            },
        });
        onClick?.();
    };

    return (
        <CampaignCardCompact {...props} campaign={campaign} index={index} onClick={handleClick} />
    );
};

export { CampaignsCarouselCard };
